import { render, staticRenderFns } from "./InventoryBarcode.vue?vue&type=template&id=205f4532"
import script from "./InventoryBarcode.vue?vue&type=script&lang=js"
export * from "./InventoryBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports